import { SrInsightType as InsightType } from '@plato/data/starrocks/types';
import type { TranslationFunction } from '../../../lib/hooks/use-locale.ts';
import type { InsightDTO } from '../../../server/dto/insight-dto.ts';

export const getInsightName = (t: TranslationFunction, insight: InsightDTO): string => {
    if (insight.insight_type === InsightType.INDUSTRY_TOP) {
        return t(`insight_name__${insight.insight_type}`, {
            ns: 'insights',
            industry_sector: insight.template_arguments?.industry_sector,
        });
    }

    return t(`insight_name__${insight.insight_type}`, {
        ns: 'insights',
    });
};
